export type SvgEl = React.HTMLAttributes<HTMLOrSVGElement>;

export const IconCircleQuestion: React.FC<SvgEl> = (props: SvgEl) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
      <path d="M40.5 21.7c-7 0-11 3.6-12 9.2l2.3 1.3c.7-5 3.8-8 9.5-8 5.3 0 8.5 2.7 8.5 7 0 4.9-2.7 7.4-10.3 9.1v7.8h2.7v-6.3c6.5-1.4 10.4-4.7 10.4-10.9 0-5.7-4.6-9.2-11.1-9.2zm-.8 31.7a2.4 2.4 0 102.5 2.5 2.3 2.3 0 00-2.5-2.5zM40 0a40 40 0 1040 40A40 40 0 0040 0zm0 76.7A36.7 36.7 0 1176.7 40 36.8 36.8 0 0140 76.7z" />
    </svg>
  );
};
